import { render, staticRenderFns } from "./BgVideo.vue?vue&type=template&id=0573b8ff"
import script from "./BgVideo.vue?vue&type=script&lang=ts"
export * from "./BgVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports